import { Badge, TableColumn, utils } from "@vilocnv/allsetra-core";
import { getResolvedAddress } from "app/data/helpers";
import {
  COMMON_REPORT_INNER_TABLE_COLUMNS,
  COMMON_REPORT_TABLE_COLUMNS,
  RIDE_MODE_IDENTIFICATION
} from "./commonReportsConstants";
import { Box, Stack } from "@mui/material";
import LocationLink from "components/ui/links";
import { MovingArrowLeft } from "assets/icons/common/MovingArrowLeft";
import { HiddenBadgeIcon } from "components/ui/icons";
import {
  renderAddressCell,
  getResolvedAddressForCell
} from "app/data/helpers/ReportHelpers/addressRenderHelper";

/**
 * MILAGE REGISTRATION
 */

export const MILAGE_REGISTRATION_DATE_RENDERING: TableColumn<any>[] = [
  { selector: (row: any) => row.label }
];

export const MILAGE_REGISTRATION_TABLE_COLUMNS = (
  translator: any,
  isShowKeyCol: boolean
): TableColumn<any>[] => [
  {
    name: translator("tableHeading.ride", { ns: "tableHeadingsTranslation" }),
    selector: (row: any) => row?.name || "N/A",
    wrap: true
  },
  {
    name: translator("tableHeading.startTime", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.endTime", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.startMileage", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.endMileage", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.startAddress", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.endAddress", {
      ns: "tableHeadingsTranslation"
    })
  },
  ...COMMON_REPORT_TABLE_COLUMNS(translator, isShowKeyCol),
  {
    name: translator("tableHeading.comments", {
      ns: "tableHeadingsTranslation"
    })
  }
];

export const MILAGE_REG_INNER_TABLE_COLUMNS = (
  translator: any,
  resolvedAddress: Array<any>,
  showMovementRides: boolean,
  isShowKeyCol?: boolean,
  resolvedAddressLoading?: boolean
) => {
  return [
    { selector: (row: any) => row?.rideId || "-" },
    {
      selector: (row: any) => (
        <Stack spacing={2}>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <div>{utils.formatDate({ date: row?.startDate }) || "-"}</div>
            {row?.startedWithoutIginition && showMovementRides && (
              <MovingArrowLeft
                label={translator("common.movementRide") ?? "Movement ride"}
              />
            )}
          </Stack>
        </Stack>
      ),
      wrap: true
    },
    {
      selector: (row: any) =>
        row?.endDate !== null ? utils.formatDate({ date: row?.endDate }) : "-",
      wrap: true
    },
    {
      cell: (row: any) =>
        row?.startMileage
          ? `${row?.startMileage.toFixed(1).replace(".", ",")} km`
          : "N/A"
    },
    {
      cell: (row: any) =>
        row?.endMileage
          ? `${row?.endMileage.toFixed(1).replace(".", ",")} km`
          : "N/A"
    },
    {
      cell: (row: any) => {
        const resolvedStartAddress = getResolvedAddressForCell(
          row,
          resolvedAddress,
          "start"
        );

        return renderAddressCell({
          latitude: row.startLatitude,
          longitude: row.startLongitude,
          resolvedAddress: resolvedStartAddress,
          translator,
          isLoading: resolvedAddressLoading,
          rideMode: row.rideMode
        });
      },
      wrap: true
    },
    {
      cell: (row: any) => {
        const resolvedEndAddress = getResolvedAddressForCell(
          row,
          resolvedAddress,
          "end"
        );

        return renderAddressCell({
          latitude: row.endLatitude,
          longitude: row.endLongitude,
          resolvedAddress: resolvedEndAddress,
          translator,
          isLoading: resolvedAddressLoading,
          rideMode: row.rideMode
        });
      },
      wrap: true
    },
    ...COMMON_REPORT_INNER_TABLE_COLUMNS(translator, isShowKeyCol),
    {
      cell: (row: any) => row?.comments || "-"
    }
  ];
};

export const MILAGE_REG_HEADERS = [
  { label: "Object Name", key: "Object Name" },
  { label: "Ride", key: "Ride" },
  { label: "Start Mileage", key: "Start Mileage" },
  { label: "End Mileage", key: "End Mileage" },
  { label: "Start Time", key: "Start Time" },
  { label: "End Time", key: "End Time" },
  { label: "Start Address", key: "Start Address" },
  { label: "End Address", key: "End Address" },
  { label: "Key", key: "Key" },
  { label: "Driver", key: "Driver" },
  { label: "Ride Mode", key: "Ride Mode" },
  { label: "Distance", key: "Distance" },
  { label: "Ride Duration", key: "Ride Duration" },
  { label: "Comments", key: "Comments" }
];
